/** English UI source strings. Keep keys stable. */
export const en = {
  'nav.deposits': 'Wallet top-up requests',
  'nav.compliance': 'Compliance',
  'nav.users': 'Users',
  'nav.dashboard': 'Dashboard',
  'common.retry': 'Retry',
  'common.refresh': 'Refresh',
  'common.search': 'Search',
  'common.status': 'Status',
  'common.all': 'All',
  'common.pending': 'Pending',
  'common.approved': 'Approved',
  'common.rejected': 'Rejected',
  'deposits.title': 'Wallet top-up requests',
  'deposits.subtitle': 'Review units and games wallet top-up requests.',
  'deposits.empty': 'No deposit requests',
  'errors.generic': 'Something went wrong. Please try again.',
} as const;

export type MessageKey = keyof typeof en;
